import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const WidePanelLogRoot = styled.div(props => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: theme(props).pageLayout.sidebar.wideModeWidth.css(),
    overflow: "hidden",
}));

export const MainContent = styled.div({
    display: "flex",
    justifyContent: "stretch",
    flexDirection: "column",

    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "100%",
    overflow: "hidden",
});

export const Footer = styled.div<{ isFixed?: boolean }>(props => ({
    flexGrow: 0,
    flexShrink: 0,
    padding: "0 0 12px 0",
    margin: "0 16px",
    boxSizing: "border-box",
    borderTop: props.isFixed ? theme(props).border.solid : "none",
}));

export const PrintErrorlogContainer = styled.ul({
    padding: "4px 0",
    margin: "12px 0 8px 0",
});

export const PaymentBannerContainer = styled.div(props => ({
    marginBottom: theme(props).size(2),
}));

export const ActionButtons = styled.div<{ errors: boolean }>(props => ({
    paddingTop: props.errors ? "0" : "45px",
}));

export const ERROR_COUNTERS_HEIGHT = 36;
export const ERROR_COUNTERS_INDENT = 8;
export const ErrorCountersContainer = styled.div(props => ({
    display: "inline-block",
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: ERROR_COUNTERS_HEIGHT,
    boxSizing: "border-box",
    width: theme(props).pageLayout.sidebar.wideModeWidth.css(),
    paddingLeft: 26,
    paddingTop: 16,
    paddingBottom: ERROR_COUNTERS_INDENT,
}));

export const ResultContainer = styled.div({
    textAlign: "center",
    padding: `0 20px`,
});
